export default __webpack_public_path__ + "static/media/by_11.710072e5.mp3";